function LoadingTransparent({ message = 'Loading...' }) {
    return (
        <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center z-50'>
            <div className='absolute inset-0 bg-slate-900 bg-opacity-50 backdrop-blur-sm'></div>
            
            <div className='relative z-10 flex flex-col items-center gap-4'>
                <div className='w-12 h-12 rounded-full border-4 border-slate-300 border-t-blue-500 animate-spin'></div>

                {message && (
                    <p className='text-white font-medium text-sm bg-slate-800 bg-opacity-80 px-4 py-2 rounded-lg'>
                        {message}
                    </p>
                )}
            </div>
        </div>
    );
}

export default LoadingTransparent;
